// CSV Export utility for blockchain transactions
export const exportToCSV = (transactions, filename = 'kibouor-transactions.csv') => {
  if (!transactions || transactions.length === 0) {
    console.warn('No transactions to export');
    return;
  }

  // CSV headers
  const headers = ['Transaction Hash', 'Date', 'Amount (USD)', 'From', 'Status'];
  
  // Convert transactions to CSV format
  const csvContent = [
    headers.join(','),
    ...transactions.map(tx => [
      `"${tx.tx}"`,
      `"${tx.date}"`,
      `"$${tx.amount_usd.toLocaleString()}"`,
      `"${tx.from}"`,
      `"${tx.status}"`
    ].join(','))
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

// Format transaction for display
export const formatTransaction = (tx) => {
  return {
    ...tx,
    shortHash: `${tx.tx.slice(0, 6)}...${tx.tx.slice(-4)}`,
    formattedAmount: `$${tx.amount_usd.toLocaleString()}`,
    formattedDate: new Date(tx.date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  };
};

// Calculate total amount from transactions
export const calculateTotal = (transactions) => {
  return transactions.reduce((sum, tx) => sum + tx.amount_usd, 0);
};
